import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  letter-spacing: -0.14px;
  line-height: 20px;
`;

export const Toolbar = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;
  color: rgba(0, 0, 0, 0.88);
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const Body = styled.div`
  display: flex;
  padding: 0 16px 16px 44px;
  gap: 16px;
`;

export const BodyLeftContainer = styled.div`
  width: 100%;
  padding-bottom: 8px;
`;
export const BodyRightContainer = styled.div`
  width: 375px;
  padding-left: 8px;
`;

export const CustomDimensionDescription = styled.div`
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;

  height: 40px;

  display: flex;
  align-items: center;
`;

export const RuleBuilder = styled.div`
  padding: 16px 24px;

  display: flex;
  flex-direction: column;
`;

export const DimensionNameCategoryContainer = styled.div`
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  background: #f6f6f6;
  padding: 8px 16px 16px 16px;

  display: flex;
  gap: 16px;
  flex-direction: column;
`;
export const DimensionNameCategoryLabel = styled.div`
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 8px;
`;

export const MismatchNotification = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 9px;

  & > span {
    line-height: 28px;
    background-color: #fff9f2;
    color: #ff9300;
    font-weight: 500;
    border-radius: 4px;
    padding: 0 8px;
  }
`;
